/** REK-1505: compact line on magic-link / OTP waiting screens (REK-1493 deliverability follow-up). */
export const AUTH_EMAIL_SPAM_FOLDER_HINT =
  'Check spam or junk—it may take a minute to arrive.';

/**
 * REK-1930: format a remaining-cooldown duration as a "M:SS" timer string
 * (e.g. 905 -> "15:05", 45 -> "0:45"). Negative/zero values clamp to "0:00".
 */
export function formatCooldownTimer(seconds: number): string {
  const safe = Number.isFinite(seconds) && seconds > 0 ? Math.ceil(seconds) : 0;
  const mins = Math.floor(safe / 60);
  const secs = safe % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

/**
 * Static sentence shared by both the known- and unknown-window variants. Used
 * on its own as the one-shot screen-reader announcement so the ticking
 * countdown (which changes every second) is not re-announced repeatedly.
 */
export const LOGIN_RATE_LIMIT_BASE =
  'Too many login links requested. Check your email and spam folder.';

/**
 * REK-1930: rate-limit message for the login OTP flow. The login magic-link
 * resend limit is 3 requests / 15 minutes per IP (enforced in
 * `multi-email-auth` `sign-in-otp`). When the user tops it, this message
 * explains the trigger and (when the backend reports the remaining window) ticks
 * down a live countdown until the Send Link button re-enables.
 *
 * @param secondsRemaining - whole seconds left in the cooldown window, or
 *   `null`/`0` when the precise remaining time is unknown (e.g. the edge
 *   function has not been redeployed yet with the `retryAfter` field).
 */
export function loginRateLimitMessage(secondsRemaining: number | null): string {
  if (secondsRemaining && secondsRemaining > 0) {
    return `${LOGIN_RATE_LIMIT_BASE} You can request another code in ${formatCooldownTimer(secondsRemaining)}.`;
  }
  return `${LOGIN_RATE_LIMIT_BASE} Please try again in a few minutes.`;
}
